(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aurea-bundle-builder"]) return;
  try {
    
(() => {
  const states = new WeakMap();
  const format = (template, values) => Object.entries(values).reduce((text, [key, value]) => text.replaceAll(`__${key}__`, String(value)), template || '');
  const normalized = value => value.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim();
  const money = (dialog, cents) => {
    let amount = (Math.round(cents) / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    amount = amount.replace(/\.00$/, '');
    const template = dialog.dataset.moneyFormat || '';
    const pattern = /\{\{\s*[a-z_]+\s*\}\}/;
    return pattern.test(template) ? template.replace(pattern, amount) : `$ ${amount}`;
  };
  const tierPercent = count => count >= 4 ? 30 : count === 3 ? 20 : count === 2 ? 10 : 0;
  const getState = dialog => {
    if (!states.has(dialog)) {
      const products = new Map(Array.from(dialog.querySelectorAll('[data-a-pack-product]')).map(card => [card.dataset.variant, {
        card,
        id: card.dataset.variant,
        name: card.dataset.name,
        stock: Number(card.dataset.stock),
        max: Number(card.dataset.max),
        cartQuantity: Number(card.dataset.cartQuantity),
        image: card.querySelector('img')
      }]));
      states.set(dialog, { products, cart: null, family: '', search: '', busy: false, blocked: false, opener: null, previousOverflow: '' });
      dialog.addEventListener('close', () => {
        const state = states.get(dialog);
        if (!document.querySelector('dialog[open]')) {
          document.documentElement.style.overflow = state.previousOverflow;
          if (state.opener?.isConnected) state.opener.focus({ preventScroll: true });
        }
        document.dispatchEvent(new CustomEvent('aurea:builder:toggle', { detail: { open: false } }));
      });
    }
    return states.get(dialog);
  };
  const remainingStock = product => Math.max(0, Math.min(product.stock < 0 ? Infinity : product.stock, product.max < 0 ? Infinity : product.max) - product.cartQuantity);
  const showError = (dialog, text, focus = false) => {
    const error = dialog.querySelector('[data-a-pack-error]');
    error.textContent = text;
    error.hidden = !text;
    if (focus && text && dialog.open) error.focus({ preventScroll: false });
  };
  const announce = (dialog, text) => {
    const status = dialog.querySelector('[data-a-pack-status]');
    status.textContent = '';
    window.setTimeout(() => { status.textContent = text; }, 30);
  };
  const eligibleItems = (dialog, cart) => {
    const price = Number(dialog.dataset.eligiblePrice);
    return (cart?.items || []).filter(item => Number(item.original_price) === price || (item.original_price == null && Number(item.price) === price));
  };
  const readCart = async dialog => {
    const response = await fetch(`${dialog.dataset.cartUrl}.js`, { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('cart_unavailable');
    const cart = await response.json();
    if (!Array.isArray(cart.items)) throw new Error('cart_unavailable');
    return cart;
  };
  const syncCart = (dialog, cart) => {
    const state = getState(dialog);
    state.cart = cart;
    state.products.forEach(product => { product.cartQuantity = cart.items.filter(item => String(item.variant_id) === product.id).reduce((sum, item) => sum + item.quantity, 0); });
    if (cart.currency && cart.currency !== 'MXN') {
      state.blocked = true;
      showError(dialog, dialog.dataset.currencyError);
    }
  };
  const refreshTheme = () => {
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.dispatchEvent(new CustomEvent('aurea:cart:updated'));
  };
  const productName = (state, item) => state.products.get(String(item.variant_id))?.name || String(item.product_title || '').split('·').pop().trim();
  const productImage = (state, item) => {
    const card = state.products.get(String(item.variant_id));
    if (card?.image) return card.image.currentSrc || card.image.src;
    if (!item.image) return '';
    return item.image.includes('?') ? `${item.image}&width=120` : `${item.image}?width=120`;
  };
  const render = dialog => {
    const state = getState(dialog);
    const data = dialog.dataset;
    const cart = state.cart;
    const items = eligibleItems(dialog, cart);
    const units = [];
    items.forEach(item => { for (let i = 0; i < item.quantity; i++) units.push(item); });
    const count = units.length;
    const percent = tierPercent(count);
    const disabled = state.busy || state.blocked;

    dialog.querySelectorAll('[data-a-pack-tier]').forEach(tier => {
      const level = Number(tier.dataset.aPackTier);
      const active = level === 4 ? count >= 4 : count === level;
      tier.dataset.active = String(active);
      tier.dataset.reached = String(count >= level);
      tier.querySelector('[data-a-pack-tier-current]').hidden = !active;
      if (active) tier.setAttribute('aria-current', 'step'); else tier.removeAttribute('aria-current');
    });

    dialog.querySelector('[data-a-pack-progress]').textContent = count === 1 ? data.progressOne : format(data.progress, { count });
    dialog.querySelectorAll('[data-a-pack-seg]').forEach((seg, index) => { seg.dataset.on = String(index < Math.min(count, 4)); });
    dialog.querySelector('[data-a-pack-message]').textContent = data[`msg-${Math.min(count, 4)}`] || dialog.getAttribute(`data-msg-${Math.min(count, 4)}`);

    const slots = dialog.querySelector('[data-a-pack-slots]');
    const activeRemoval = document.activeElement?.closest('[data-a-pack-remove]');
    const focusedSlot = activeRemoval && slots.contains(activeRemoval) ? Number(activeRemoval.dataset.slot) : -1;
    const fragment = document.createDocumentFragment();
    const template = dialog.querySelector('[data-a-pack-slot-template]');
    for (let index = 0; index < 4; index++) {
      const slot = template.content.cloneNode(true);
      const item = units[index];
      slot.querySelector('[data-a-pack-slot-number]').textContent = String(index + 1).padStart(2, '0');
      slot.querySelector('[data-a-pack-slot-name]').textContent = item ? productName(state, item) : data.emptySlot;
      if (item) {
        slot.querySelector('li').classList.add('a-pack-slot--filled');
        const image = slot.querySelector('img');
        const src = productImage(state, item);
        if (src) { image.src = src; image.hidden = false; }
        const remove = slot.querySelector('[data-a-pack-remove]');
        remove.hidden = false;
        remove.disabled = disabled;
        remove.dataset.key = item.key;
        remove.dataset.quantity = String(item.quantity);
        remove.dataset.title = productName(state, item);
        remove.dataset.slot = String(index);
        remove.setAttribute('aria-label', format(data.removeProduct, { title: productName(state, item) }));
      }
      fragment.append(slot);
    }
    slots.replaceChildren(fragment);
    if (focusedSlot >= 0) {
      const remove = slots.querySelector(`[data-slot="${Math.min(focusedSlot, count - 1)}"]`);
      (remove || dialog.querySelector('[data-a-pack-search]')).focus({ preventScroll: true });
    }
    const more = dialog.querySelector('[data-a-pack-more]');
    more.hidden = count <= 4;
    more.textContent = count > 4 ? format(data.more, { count: count - 4 }) : '';

    state.products.forEach(product => {
      const quantity = product.cartQuantity;
      product.card.dataset.selected = String(quantity > 0);
      const picked = product.card.querySelector('[data-a-pack-picked]');
      picked.hidden = quantity === 0;
      picked.textContent = String(quantity);
      picked.setAttribute('aria-label', format(data.inCartLabel, { count: quantity }));
      const add = product.card.querySelector('[data-a-pack-add]');
      if (add.getAttribute('aria-busy') !== 'true') product.card.querySelector('[data-a-pack-add-text]').textContent = quantity ? data.anotherLabel : data.addLabel;
      add.disabled = disabled || remainingStock(product) <= 0;
    });

    const eligiblePrice = Number(data.eligiblePrice);
    const original = cart ? Number(cart.original_total_price ?? cart.items_subtotal_price ?? 0) : eligiblePrice * count;
    const expected = Math.round(eligiblePrice * count * percent / 100);
    const cartDiscount = cart ? Number(cart.total_discount || 0) : 0;
    const provisional = percent > 0 && cartDiscount === 0;
    const discount = provisional ? expected : cartDiscount;
    const itemsTotal = cart ? (provisional ? Math.max(0, original - expected) : Number(cart.total_price)) : Math.max(0, original - expected);
    /* Envío gratis solo desde 3 fragancias elegibles ($599). Con 1 o 2 se suma el envío estándar ($150). */
    const freeShipping = count >= 3;
    const hasItems = cart ? cart.item_count > 0 : count > 0;
    const needsShipping = cart ? cart.requires_shipping !== false : true;
    const shipping = hasItems && needsShipping && !freeShipping ? Number(data.shippingFee) : 0;

    dialog.querySelector('[data-a-pack-subtotal]').textContent = money(dialog, original);
    const discountRow = dialog.querySelector('[data-a-pack-discount-row]');
    discountRow.hidden = discount <= 0;
    dialog.querySelector('[data-a-pack-discount-label]').textContent = format(data.discountLabel, { percent: percent || Math.round(discount / Math.max(original, 1) * 100) });
    dialog.querySelector('[data-a-pack-discount]').textContent = `−${money(dialog, discount)}`;
    dialog.querySelector('[data-a-pack-shipping]').textContent = !hasItems ? '—' : freeShipping ? data.free : money(dialog, shipping);
    const total = itemsTotal + shipping;
    dialog.querySelector('[data-a-pack-total]').textContent = money(dialog, total);
    dialog.querySelector('[data-a-pack-note]').hidden = !provisional;

    const emptyCta = dialog.querySelector('[data-a-pack-empty-cta]');
    const checkout = dialog.querySelector('[data-a-pack-checkout]');
    emptyCta.hidden = count > 0;
    checkout.hidden = count === 0;
    checkout.textContent = format(data.checkoutLabel, { total: money(dialog, total) });
    checkout.setAttribute('aria-disabled', String(disabled));
  };
  const filterProducts = dialog => {
    const state = getState(dialog);
    let visible = 0;
    state.products.forEach(product => {
      const matches = (!state.family || product.card.dataset.family === state.family) && (!state.search || normalized(product.card.dataset.search).includes(state.search));
      product.card.hidden = !matches;
      if (matches) visible++;
    });
    dialog.querySelectorAll('[data-a-pack-filter]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.aPackFilter === state.family)));
    dialog.querySelector('[data-a-pack-no-results]').hidden = visible > 0;
  };
  const reload = async dialog => {
    try {
      syncCart(dialog, await readCart(dialog));
    } catch (_) {
      showError(dialog, dialog.dataset.cartError);
    }
    render(dialog);
  };
  const open = async (dialog, opener) => {
    const state = getState(dialog);
    state.opener = opener;
    const finder = document.getElementById('AureaFinder');
    const finderWasOpen = Boolean(finder?.open);
    if (finderWasOpen) finder.close();
    const drawer = document.getElementById('cart-drawer');
    if (drawer?.hasAttribute('open') && typeof drawer.hide === 'function') drawer.hide();
    document.querySelectorAll('.a-menu[open]').forEach(menu => menu.removeAttribute('open'));
    if (!dialog.open) {
      state.previousOverflow = finderWasOpen ? '' : document.documentElement.style.overflow;
      dialog.showModal();
    }
    document.documentElement.style.overflow = 'hidden';
    document.dispatchEvent(new CustomEvent('aurea:builder:toggle', { detail: { open: true } }));
    showError(dialog, '');
    render(dialog);
    filterProducts(dialog);
    dialog.querySelector('#AureaPackTitle').focus({ preventScroll: true });
    if (dialog.dataset.currency && dialog.dataset.currency !== 'MXN') {
      state.blocked = true;
      showError(dialog, dialog.dataset.currencyError);
      render(dialog);
      return;
    }
    await reload(dialog);
  };
  const mutate = async (dialog, url, body, button, messages) => {
    const state = getState(dialog);
    if (state.busy || state.blocked) return;
    state.busy = true;
    showError(dialog, '');
    if (button) {
      button.setAttribute('aria-busy', 'true');
      const text = button.querySelector('[data-a-pack-add-text]');
      if (text) text.textContent = dialog.dataset.adding;
    }
    render(dialog);
    let ok = false;
    try {
      const response = await fetch(url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(body) });
      if (response.status === 422) {
        showError(dialog, messages.stock, true);
      } else if (!response.ok) {
        throw new Error('cart_request_failed');
      } else {
        ok = true;
      }
    } catch (_) {
      showError(dialog, dialog.dataset.requestError, true);
    }
    try {
      syncCart(dialog, await readCart(dialog));
    } catch (_) {
      if (ok) showError(dialog, dialog.dataset.cartError);
    }
    state.busy = false;
    if (button) button.removeAttribute('aria-busy');
    render(dialog);
    if (ok) announce(dialog, messages.success);
    refreshTheme();
  };
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const opener = event.target.closest('[data-a-build-bundle]');
    const dialog = document.getElementById('AureaBundleBuilder');
    if (!dialog) return;
    if (opener && !dialog.contains(opener)) {
      event.preventDefault();
      open(dialog, opener);
      return;
    }
    if (!dialog.contains(event.target)) return;
    const state = getState(dialog);
    if (event.target.closest('[data-a-pack-close]')) {
      dialog.close();
      return;
    }
    const checkout = event.target.closest('[data-a-pack-checkout]');
    if (checkout && (state.busy || state.blocked)) {
      event.preventDefault();
      return;
    }
    const filter = event.target.closest('[data-a-pack-filter]');
    if (filter) {
      state.family = filter.dataset.aPackFilter;
      filterProducts(dialog);
      return;
    }
    const add = event.target.closest('[data-a-pack-add]');
    if (add && !add.disabled) {
      const product = state.products.get(add.closest('[data-a-pack-product]').dataset.variant);
      if (!product) return;
      if (remainingStock(product) <= 0) {
        showError(dialog, format(dialog.dataset.stockError, { title: product.name }), true);
        return;
      }
      mutate(dialog, dialog.dataset.addUrl, { items: [{ id: Number(product.id), quantity: 1 }] }, add, {
        success: format(dialog.dataset.added, { title: product.name }),
        stock: format(dialog.dataset.stockError, { title: product.name })
      });
      return;
    }
    const remove = event.target.closest('[data-a-pack-remove]');
    if (remove && !remove.disabled && remove.dataset.key) {
      mutate(dialog, dialog.dataset.changeUrl, { id: remove.dataset.key, quantity: Math.max(0, Number(remove.dataset.quantity) - 1) }, null, {
        success: format(dialog.dataset.removed, { title: remove.dataset.title }),
        stock: dialog.dataset.requestError
      });
    }
  });
  document.addEventListener('input', event => {
    if (!(event.target instanceof Element) || !event.target.matches('[data-a-pack-search]')) return;
    const dialog = event.target.closest('#AureaBundleBuilder');
    if (!dialog) return;
    const state = getState(dialog);
    state.search = normalized(event.target.value);
    filterProducts(dialog);
  });
  window.addEventListener('pageshow', event => {
    if (!event.persisted) return;
    const dialog = document.getElementById('AureaBundleBuilder');
    if (!dialog || !states.has(dialog)) return;
    const state = states.get(dialog);
    state.busy = false;
    if (dialog.open) reload(dialog);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aurea-system"]) return;
  try {
    
(() => {
  let opener;
  const finder = () => document.getElementById('AureaFinder');
  function reset(dialog) {
    dialog.querySelector('[data-a-questions]').hidden = false;
    dialog.querySelector('[data-a-matches]').hidden = true;
  }
  document.addEventListener('click', (event) => {
    const openButton = event.target.closest('[data-a-finder]');
    const dialog = finder();
    if (openButton && dialog) {
      opener = openButton;
      document.querySelectorAll('.a-menu[open]').forEach(menu => menu.removeAttribute('open'));
      reset(dialog);
      dialog.showModal();
      document.documentElement.style.overflow = 'hidden';
    }
    if (event.target.closest('[data-a-close]') && dialog) dialog.close();
    if (event.target.closest('[data-a-reset]') && dialog) {
      reset(dialog);
      dialog.querySelector('input:checked').focus();
    }
    if (event.target.closest('[data-a-results]') && dialog) {
      const familyInput = dialog.querySelector('[name="a-family"]:checked');
      const occasionInput = dialog.querySelector('[name="a-occasion"]:checked');
      const family = familyInput.value;
      const occasion = occasionInput.value;
      const selectedReason = [familyInput.dataset.reason, occasionInput.dataset.reason].filter(Boolean).join(' · ');
      let shown = 0;
      dialog.querySelectorAll('[data-a-product]').forEach(product => {
        const tags = product.dataset.tags.split('|');
        const match = (!family || tags.includes(family)) && (!occasion || tags.includes(occasion));
        product.hidden = !match || shown >= 4;
        if (match && shown < 4) {
          const reason = product.querySelector('[data-a-match-reason]');
          reason.textContent = selectedReason || reason.dataset.defaultReason;
          reason.hidden = !reason.textContent;
          shown++;
        }
      });
      dialog.querySelector('.a-finder-empty').hidden = shown > 0;
      dialog.querySelector('[data-a-questions]').hidden = true;
      const results = dialog.querySelector('[data-a-matches]');
      const description = family && occasion ? results.dataset.bothDescription : family ? results.dataset.familyDescription : occasion ? results.dataset.occasionDescription : results.dataset.discoverDescription;
      const matchIntro = results.querySelector('[data-a-match-intro]');
      matchIntro.textContent = description;
      matchIntro.hidden = shown === 0;
      results.hidden = false;
      results.focus();
      dialog.scrollTop = 0;
    }
    if (!event.target.closest('.a-menu')) document.querySelectorAll('.a-menu[open]').forEach(menu => menu.removeAttribute('open'));
  });
  document.addEventListener('close', (event) => {
    if (event.target.id === 'AureaFinder' && !document.querySelector('dialog[open]')) {
      document.documentElement.style.overflow = '';
      opener?.focus();
    }
  }, true);
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') document.querySelectorAll('.a-menu[open]').forEach(menu => menu.removeAttribute('open'));
  });
})();

  } catch(e) { console.error(e); }
})();
})();
